"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ADD_CONTRACT: function() {
        return ADD_CONTRACT;
    },
    DELETE_CONTRACT: function() {
        return DELETE_CONTRACT;
    },
    DUPLICATE_CONTRACT: function() {
        return DUPLICATE_CONTRACT;
    },
    GENERATE_CONTRACTS: function() {
        return GENERATE_CONTRACTS;
    },
    RESET_CONTRACTS: function() {
        return RESET_CONTRACTS;
    },
    UPDATE_CONTRACT: function() {
        return UPDATE_CONTRACT;
    }
});
const ADD_CONTRACT = "ADD_CONTRACT";
const UPDATE_CONTRACT = "UPDATE_CONTRACT";
const DELETE_CONTRACT = "DELETE_CONTRACT";
const GENERATE_CONTRACTS = "GENERATE_CONTRACTS";
const RESET_CONTRACTS = "RESET_CONTRACTS";
const DUPLICATE_CONTRACT = "DUPLICATE_CONTRACT";
